import React from "react"

import classNames from "classnames"

import { WithClassName } from "shared/types/WithClassName"

export interface ProjectCardDividerProps extends WithClassName {}

export const ProjectCardDivider = React.memo(
  ({ className }: ProjectCardDividerProps) => {
    return (
      <div
        className={classNames("project-card__divider", className)}
        aria-hidden="true"
      />
    )
  }
)
